
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignEmbarkationLadder as ObiSignEmbarkationLadderElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-embarkation-ladder.js';
 
 
 

 
 export const ObiSignEmbarkationLadder = createComponent({
   react: React,
   tagName: 'obi-sign-embarkation-ladder',
   elementClass: ObiSignEmbarkationLadderElement,
   events: {
     
   }
  });
 
 